export const categories = [
  { slug: 'lianai', name: '恋爱', icon: 'ri-heart-line', description: '甜蜜浪漫的恋爱韩漫，让你感受心动的每一刻' },
  { slug: 'qihuan', name: '奇幻', icon: 'ri-magic-line', description: '充满想象力的奇幻世界，带你穿越异世界冒险' },
  { slug: 'dongzuo', name: '动作', icon: 'ri-sword-line', description: '热血沸腾的战斗场面，紧张刺激的动作韩漫' },
  { slug: 'xuanyi', name: '悬疑', icon: 'ri-eye-line', description: '扣人心弦的悬疑故事，烧脑推理停不下来' },
  { slug: 'gaoxiao', name: '搞笑', icon: 'ri-emotion-happy-line', description: '欢乐轻松的搞笑韩漫，让你笑到停不下来' },
  { slug: 'juqing', name: '剧情', icon: 'ri-book-read-line', description: '深度剧情的精品韩漫，引人入胜的故事叙述' },
  { slug: 'gufeng', name: '古风', icon: 'ri-vip-crown-line', description: '唯美古风韩漫，带你领略东方古典韵味' },
  { slug: 'xiaoyuan', name: '校园', icon: 'ri-school-line', description: '青春洋溢的校园韩漫，记录最美好的年少时光' },
];

export const manhwaList = [
  {
    id: 1,
    slug: 'wo-de-nu-shen-shi-xue-ba',
    title: '我的女神是学霸',
    author: '金智恩',
    category: 'lianai',
    categoryName: '恋爱',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20beautiful%20female%20student%20with%20glasses%20holding%20books%2C%20romantic%20school%20scene%2C%20soft%20warm%20lighting%2C%20clean%20illustration%20style%2C%20pastel%20colors%2C%20simple%20cream%20background%2C%20anime%20inspired%20art%2C%20high%20quality%20digital%20painting&width=600&height=800&seq=manhwa-cover-01&orientation=portrait',
    rating: 4.8,
    chapters: 156,
    status: '连载中',
    description: '平凡的高中生李哲宇暗恋着全校第一的学霸林秀雅，一次偶然的机会让他们成为了同桌。从此，李哲宇的生活发生了翻天覆地的变化。学霸女神的温柔与严厉并存，让这段校园恋爱充满了欢笑与感动。',
    updatedAt: '2026-08-03',
    featured: true,
    trending: 1,
    views: 1280000,
  },
  {
    id: 2,
    slug: 'yi-shi-jie-zhi-wang',
    title: '异世界之王',
    author: '朴在贤',
    category: 'qihuan',
    categoryName: '奇幻',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20illustration%20of%20a%20warrior%20with%20cape%20in%20magical%20world%2C%20epic%20fantasy%20scene%2C%20dramatic%20lighting%2C%20clean%20illustration%20style%2C%20warm%20earthy%20tones%2C%20simple%20background%2C%20anime%20inspired%20digital%20art%2C%20high%20quality%20painting&width=600&height=800&seq=manhwa-cover-02&orientation=portrait',
    rating: 4.9,
    chapters: 203,
    status: '连载中',
    description: '普通上班族金泰浩意外穿越到剑与魔法的异世界，凭借现代知识和超强适应力，一步步从底层冒险者成长为异世界最强王者。宏大的世界观，精彩绝伦的战斗场面，不容错过的奇幻巨作！',
    updatedAt: '2026-08-04',
    featured: true,
    trending: 2,
    views: 2150000,
  },
  {
    id: 3,
    slug: 'an-sha-zhe-ri-ji',
    title: '暗杀者日记',
    author: '崔玄宇',
    category: 'dongzuo',
    categoryName: '动作',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20illustration%20of%20a%20mysterious%20assassin%20in%20black%20coat%2C%20dark%20alley%20scene%2C%20dramatic%20shadow%20lighting%2C%20clean%20illustration%20style%2C%20moody%20atmosphere%2C%20simple%20dark%20background%2C%20anime%20inspired%20digital%20art%2C%20high%20quality%20painting&width=600&height=800&seq=manhwa-cover-03&orientation=portrait',
    rating: 4.7,
    chapters: 89,
    status: '连载中',
    description: '曾经的王牌杀手姜贤宇为了复仇重出江湖。每一次暗杀都是一场精密策划的艺术，而在这场复仇之路上，他发现了隐藏在暗处的惊天阴谋。紧张刺激的打斗场面，精妙的剧情设计。',
    updatedAt: '2026-08-02',
    featured: true,
    trending: 3,
    views: 960000,
  },
  {
    id: 4,
    slug: 'mi-shi-xiao-zhen',
    title: '迷失小镇',
    author: '李书妍',
    category: 'xuanyi',
    categoryName: '悬疑',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20mystery%20illustration%20of%20a%20foggy%20small%20town%20with%20silhouette%2C%20eerie%20atmosphere%2C%20mysterious%20mood%2C%20clean%20illustration%20style%2C%20muted%20cool%20tones%2C%20simple%20background%2C%20anime%20inspired%20digital%20art%2C%20high%20quality%20painting&width=600&height=800&seq=manhwa-cover-04&orientation=portrait',
    rating: 4.6,
    chapters: 67,
    status: '连载中',
    description: '五个陌生人同时收到神秘邀请函，来到一座与世隔绝的小镇。当他们发现小镇居民一个接一个离奇失踪时，才意识到自己已深陷一场精心设计的死亡游戏。环环相扣的谜题，让人欲罢不能。',
    updatedAt: '2026-07-31',
    featured: false,
    trending: 5,
    views: 780000,
  },
  {
    id: 5,
    slug: 'she-chu-ri-chang',
    title: '社畜日常',
    author: '韩敏俊',
    category: 'gaoxiao',
    categoryName: '搞笑',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comedy%20illustration%20of%20an%20office%20worker%20with%20funny%20expression%2C%20humorous%20office%20scene%2C%20bright%20warm%20colors%2C%20clean%20illustration%20style%2C%20lighthearted%20vibe%2C%20simple%20background%2C%20anime%20inspired%20digital%20art%2C%20high%20quality%20painting&width=600&height=800&seq=manhwa-cover-05&orientation=portrait',
    rating: 4.5,
    chapters: 134,
    status: '连载中',
    description: '社畜张三的爆笑职场生活！从加班地狱到奇葩同事，从不靠谱老板到神级摸鱼技巧，每一话都让人笑出腹肌。如果你也是社畜，一定能在里面找到自己的影子！',
    updatedAt: '2026-08-03',
    featured: true,
    trending: 4,
    views: 890000,
  },
  {
    id: 6,
    slug: 'huang-hun-zhi-hou',
    title: '黄昏之后',
    author: '郑雅琳',
    category: 'juqing',
    categoryName: '剧情',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20drama%20illustration%20of%20two%20people%20under%20sunset%20sky%2C%20emotional%20scene%2C%20warm%20golden%20hour%20lighting%2C%20clean%20illustration%20style%2C%20melancholic%20mood%2C%20simple%20background%2C%20anime%20inspired%20digital%20art%2C%20high%20quality%20painting&width=600&height=800&seq=manhwa-cover-06&orientation=portrait',
    rating: 4.9,
    chapters: 78,
    status: '已完结',
    description: '两个在不同时光中交错命运的人，一个关于失去与重逢的动人故事。郑雅琳用细腻的笔触描绘了人性的温暖与脆弱，被誉为近年来最好的剧情韩漫之一。',
    updatedAt: '2026-06-15',
    featured: true,
    trending: 6,
    views: 1560000,
  },
  {
    id: 7,
    slug: 'hua-jian-ci',
    title: '花间辞',
    author: '柳美英',
    category: 'gufeng',
    categoryName: '古风',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20historical%20illustration%20of%20a%20beautiful%20woman%20in%20traditional%20hanbok%20among%20cherry%20blossoms%2C%20elegant%20ancient%20Korean%20scene%2C%20soft%20pink%20and%20cream%20tones%2C%20clean%20illustration%20style%2C%20romantic%20vibe%2C%20simple%20background%2C%20anime%20inspired%20digital%20art%2C%20high%20quality%20painting&width=600&height=800&seq=manhwa-cover-07&orientation=portrait',
    rating: 4.7,
    chapters: 112,
    status: '连载中',
    description: '朝鲜王朝时期，一位才华横溢的女诗人与王世子的禁忌之恋。在诗词与花间，一段跨越身份与时代的凄美爱情徐徐展开。画面精美绝伦，每一格都是一幅艺术品。',
    updatedAt: '2026-08-01',
    featured: false,
    trending: 7,
    views: 650000,
  },
  {
    id: 8,
    slug: 'qing-chun-bi-ji-ben',
    title: '青春笔记本',
    author: '尹智慧',
    category: 'xiaoyuan',
    categoryName: '校园',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20school%20illustration%20of%20students%20in%20classroom%20with%20notebooks%2C%20youthful%20bright%20scene%2C%20fresh%20pastel%20colors%2C%20clean%20illustration%20style%2C%20nostalgic%20school%20vibe%2C%20simple%20background%2C%20anime%20inspired%20digital%20art%2C%20high%20quality%20painting&width=600&height=800&seq=manhwa-cover-08&orientation=portrait',
    rating: 4.4,
    chapters: 95,
    status: '连载中',
    description: '高中校园里，一群性格迥异的好友用笔记本记录着彼此的青春故事。友情、梦想、初恋，那些我们共同经历过的美好年华，都在这一页页中被永远珍藏。',
    updatedAt: '2026-08-02',
    featured: false,
    trending: 8,
    views: 520000,
  },
  {
    id: 9,
    slug: 'mi-mi-hua-yuan',
    title: '秘密花园',
    author: '金智恩',
    category: 'lianai',
    categoryName: '恋爱',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20illustration%20of%20a%20couple%20in%20secret%20garden%20full%20of%20flowers%2C%20dreamy%20romantic%20scene%2C%20soft%20warm%20natural%20light%2C%20clean%20illustration%20style%2C%20pastel%20floral%20colors%2C%20simple%20background%2C%20anime%20inspired%20digital%20art%2C%20high%20quality%20painting&width=600&height=800&seq=manhwa-cover-09&orientation=portrait',
    rating: 4.6,
    chapters: 145,
    status: '连载中',
    description: '大企业继承人郑秀贤隐藏身份来到花店打工，遇到了性格开朗的花艺师朴多海。在花香弥漫的秘密花园中，一段跨越阶层的浪漫爱情悄然绽放。',
    updatedAt: '2026-08-03',
    featured: false,
    trending: 9,
    views: 720000,
  },
  {
    id: 10,
    slug: 'mo-fa-shao-nv-xing-kong',
    title: '魔法少女星空',
    author: '朴在贤',
    category: 'qihuan',
    categoryName: '奇幻',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20magical%20girl%20illustration%20with%20starry%20night%20background%2C%20fantasy%20magic%20scene%2C%20sparkling%20effects%2C%20clean%20illustration%20style%2C%20dreamy%20purple%20and%20blue%20tones%2C%20simple%20background%2C%20anime%20inspired%20digital%20art%2C%20high%20quality%20painting&width=600&height=800&seq=manhwa-cover-10&orientation=portrait',
    rating: 4.5,
    chapters: 88,
    status: '连载中',
    description: '平凡初中生韩星河在某天夜晚被一颗流星选中，获得了魔法少女的力量。从此她白天是普通学生，夜晚则化身为守护城市的魔法少女。',
    updatedAt: '2026-07-30',
    featured: false,
    trending: 10,
    views: 480000,
  },
  {
    id: 11,
    slug: 'jue-ming-zhui-zong',
    title: '绝命追踪',
    author: '崔玄宇',
    category: 'dongzuo',
    categoryName: '动作',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20chase%20action%20illustration%20of%20a%20detective%20running%20in%20city%20at%20night%2C%20intense%20thriller%20scene%2C%20neon%20lighting%2C%20clean%20illustration%20style%2C%20dramatic%20urban%20colors%2C%20simple%20background%2C%20anime%20inspired%20digital%20art%2C%20high%20quality%20painting&width=600&height=800&seq=manhwa-cover-11&orientation=portrait',
    rating: 4.3,
    chapters: 56,
    status: '连载中',
    description: '刑警队长李正赫追踪连环杀手的过程中，发现案件背后隐藏着一个庞大的犯罪帝国。每一话都充满令人窒息的紧张感，拳拳到肉的打斗场面让人血脉贲张。',
    updatedAt: '2026-08-04',
    featured: false,
    trending: 11,
    views: 410000,
  },
  {
    id: 12,
    slug: 'e-meng-zhen-tan-she',
    title: '噩梦侦探社',
    author: '李书妍',
    category: 'xuanyi',
    categoryName: '悬疑',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20detective%20illustration%20of%20a%20detective%20agency%20in%20rainy%20night%2C%20noir%20mystery%20scene%2C%20moody%20lighting%2C%20clean%20illustration%20style%2C%20atmospheric%20dark%20tones%2C%20simple%20background%2C%20anime%20inspired%20digital%20art%2C%20high%20quality%20painting&width=600&height=800&seq=manhwa-cover-12&orientation=portrait',
    rating: 4.6,
    chapters: 72,
    status: '连载中',
    description: '能够进入他人梦境的女主尹素利，与退役刑警一起创办了"噩梦侦探社"。他们通过潜入委托人的梦境来解开现实中的谜团，每一个案件都诡异离奇却又直指人心。',
    updatedAt: '2026-07-29',
    featured: false,
    trending: 12,
    views: 550000,
  },
];

export const heroSlides = [
  {
    id: 1,
    slug: 'yi-shi-jie-zhi-wang',
    title: '异世界之王',
    subtitle: '年度最受欢迎奇幻韩漫',
    description: '从普通上班族到异世界最强王者，一场穿越时空的史诗冒险。宏大的世界观，精彩绝伦的战斗场面。',
    image: 'https://readdy.ai/api/search-image?query=Epic%20Korean%20manhwa%20style%20illustration%20of%20a%20fantasy%20world%20with%20castle%20and%20magic%2C%20dramatic%20cinematic%20lighting%2C%20warm%20golden%20and%20coral%20tones%2C%20artistic%20stylized%20illustration%2C%20atmospheric%20composition%2C%20clean%20illustration%20style%2C%20high%20quality%20digital%20art%2C%20no%20text&width=1400&height=700&seq=manhwa-hero-01&orientation=landscape',
    rating: 4.9,
    chapters: 203,
  },
  {
    id: 2,
    slug: 'huang-hun-zhi-hou',
    title: '黄昏之后',
    subtitle: '口碑爆棚剧情韩漫',
    description: '两个在不同时光中交错命运的人，关于失去与重逢的动人故事。已完结，一口气读完！',
    image: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20sunset%20sky%20with%20two%20silhouettes%20on%20hilltop%2C%20emotional%20dramatic%20scene%2C%20warm%20golden%20hour%20lighting%2C%20artistic%20stylized%20illustration%2C%20melancholic%20mood%2C%20clean%20illustration%20style%2C%20high%20quality%20digital%20art%2C%20no%20text&width=1400&height=700&seq=manhwa-hero-02&orientation=landscape',
    rating: 4.9,
    chapters: 78,
  },
  {
    id: 3,
    slug: 'hua-jian-ci',
    title: '花间辞',
    subtitle: '唯美古风韩漫巨献',
    description: '朝鲜王朝时期，女诗人与王世子的禁忌之恋。画面精美绝伦，每一格都是一幅艺术品。',
    image: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20cherry%20blossoms%20falling%20over%20traditional%20Korean%20palace%20garden%2C%20elegant%20historical%20scene%2C%20soft%20pink%20and%20cream%20lighting%2C%20artistic%20stylized%20illustration%2C%20romantic%20atmosphere%2C%20clean%20illustration%20style%2C%20high%20quality%20digital%20art%2C%20no%20text&width=1400&height=700&seq=manhwa-hero-03&orientation=landscape',
    rating: 4.7,
    chapters: 112,
  },
];

export const chapters = [
  { id: 1, title: '第1话 命运的开始', updatedAt: '2026-01-15' },
  { id: 2, title: '第2话 意外的相遇', updatedAt: '2026-01-22' },
  { id: 3, title: '第3话 心跳的瞬间', updatedAt: '2026-01-29' },
  { id: 4, title: '第4话 隐藏的心意', updatedAt: '2026-02-05' },
  { id: 5, title: '第5话 暴风雨前夕', updatedAt: '2026-02-12' },
  { id: 6, title: '第6话 决断的时刻', updatedAt: '2026-02-19' },
  { id: 7, title: '第7话 新的开始', updatedAt: '2026-02-26' },
  { id: 8, title: '第8话 并肩作战', updatedAt: '2026-03-05' },
  { id: 9, title: '第9话 暗流涌动', updatedAt: '2026-03-12' },
  { id: 10, title: '第10话 真相大白', updatedAt: '2026-03-19' },
  { id: 11, title: '第11话 转机', updatedAt: '2026-03-26' },
  { id: 12, title: '第12话 重逢', updatedAt: '2026-04-02' },
];

export const faqList = [
  {
    question: '韩漫网站的漫画都是免费的吗？',
    answer: '是的，我们网站上的所有韩国漫画均提供在线免费阅读。我们致力于为广大韩漫爱好者打造一个高质量的免费阅读平台，让每一位读者都能轻松享受精彩的韩国漫画。',
  },
  {
    question: '什么是下拉式韩漫阅读？',
    answer: '下拉式韩漫是一种专为手机和网页优化的漫画阅读方式。与传统的翻页模式不同，下拉式韩漫采用纵向滚动浏览，您只需向下滑动即可连续阅读，体验更加流畅自然，完美适配手机屏幕。',
  },
  {
    question: '网站多久更新一次漫画？',
    answer: '我们的编辑团队每日追踪韩国各大漫画平台的最新动态，确保漫画内容及时更新。热门连载漫画通常会在韩国首发后24-48小时内同步更新中文版本。',
  },
  {
    question: '如何找到我想看的韩国漫画类型？',
    answer: '您可以通过网站顶部的分类导航栏，按照恋爱、奇幻、动作、悬疑、搞笑、剧情、古风、校园等类型浏览漫画。也可以在首页的搜索框中直接搜索漫画名称或作者名。',
  },
  {
    question: '漫画的翻译质量怎么样？',
    answer: '我们对漫画翻译质量有着严格的要求。所有漫画均由专业翻译团队精心翻译和校对，在保证准确传达原文意思的同时，力求中文表达自然流畅，让读者获得最佳的阅读体验。',
  },
  {
    question: '可以在手机上阅读吗？',
    answer: '当然可以！我们的网站采用了响应式设计，完美适配手机、平板和电脑等各种设备。特别是下拉式韩漫的阅读模式，在手机上体验极佳，随时随地都能畅享韩漫。',
  },
];